// eslint-disable-next-line func-names
(function ($, window, Drupal) {
  if (typeof $.isArray === 'undefined') {
    $.isArray = Array.isArray;
  }

  if (typeof $.trim === 'undefined') {
    $.trim = (str) => (str == null ? '' : String(str).trim());
  }

  const initSelect2 = (el) => {
    const $selectObj = $(el).select2({
      minimumResultsForSearch: -1,
    });

    $selectObj.on('select2:select', () => {
      const value = $selectObj.val();
      const $s = $(el).siblings('.select2-container');
      const $selection = $s.find('.selection');

      if (value && value !== 0) {
        $selection.addClass('selection--highlighted');
      } else {
        $selection.removeClass('selection--highlighted');
      }
    });
  };

  Drupal.behaviors.mstSelect2 = {
    attach(context) {
      $('.js-webform-select2', context).each((index, element) => initSelect2(element));
    },
  };
}(jQuery, window, Drupal));
